import {inject} from '@angular/core';
import {TranslateService as RuntimeTranslateService} from '@ngx-translate/core';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {SiteService} from '../../../../services/site.service';
import {UserService} from '../../../../services/user.service';
import {CertificationService} from '../../../../services/certification.service';
import {ProfileService} from '../../../../services/profile.service';
import {ActivatedRoute, Router} from '@angular/router';
import Swal from 'sweetalert2';
import {SubCertificationService} from '../../../../services/sub-certification.service';
import {ConfigService} from "../../../../services/config.service";

@Component({
    selector: 'app-edit-certification',
    templateUrl: './edit-certification.component.html',
    styleUrls: ['./edit-certification.component.css'],
    standalone: false
})
export class EditCertificationComponent implements OnInit {
  private readonly runtimeTranslate = inject(RuntimeTranslateService);
  // @ts-ignore
  @ViewChild('nameSubCertification') nameSub: ElementRef;
  // @ts-ignore
  @ViewChild('descriptionSubCertification') descriptionSub: ElementRef;
  // @ts-ignore
  @ViewChild('typeValiditeSubCertification') typeValiditeSub: ElementRef;
  // @ts-ignore
  @ViewChild('dateSubCertification') dateSub: ElementRef;
  // @ts-ignore
  @ViewChild('delaySubCertification') delaySub: ElementRef;
  // @ts-ignore
  @ViewChild('idSubCertification') idSub: ElementRef;
  // tslint:disable-next-line:max-line-length
  addingSuccessSous: boolean;
  defaultSelectValidite: any;
  public array = [];
  private site_id_certification: any[] = [];
  private hiddenSiteIds: any[] = [];
  private sitesLoaded = false;
  public sites: any[] = [];
  public selectedSiteIds: any[] = [];
  public entityType = this.configService.entityType;

  // tslint:disable-next-line:max-line-length
  constructor(private configService: ConfigService, private router: Router, private activatedRoute: ActivatedRoute, private spinner: NgxSpinnerService, private siteService: SiteService, private userService: UserService, private certificationService: CertificationService, private profileService: ProfileService, private subCertificationService: SubCertificationService) { }
  // tslint:disable-next-line:variable-name
  public single_sub_certificats = {
    name: null,
    description: null,
    type_validite: null,
    date: null,
    type: null,
    delay: null,
    id: null
  };
  public certification = {
    name: null,
    description: null,
    type_validite: null,
    date: null,
    type: null,
    delay: null,
    id: null
  };
  // tslint:disable-next-line:variable-name
  public single_certificats = {
    name: null,
    description: null,
    type_validite: null,
    date: null,
    type: null,
    delay: null,
    id: null,
    code_article: null,
    code_client: null,
    theme: null
  };
  public themes = [
    'Risques généraux',
    'Risques biologiques',
    'Risques chimiques',
    'Risques informatiques',
    'Radioprotection',
    'Accueil sécurité',
    'Autres thèmes (éthique, anticorruption…)'
  ];
  // tslint:disable-next-line:variable-name radix
  public profile_id = parseInt(localStorage.getItem('profile_id'));
  public addingSuccess: boolean;
  public profiles: any;
  // tslint:disable-next-line:variable-name
  public list_sous_certificats: any;
  readioSelected: number;
  readioSelectedSous: number;



  // tslint:disable-next-line:variable-name
  certification_id: any;

  ngOnInit() {
    this.configService.checkUSerAccessByProfile(this.profile_id);
    this.get_certificat(this.activatedRoute.snapshot.url[4].path);
    this.listingSousCertificat(this.activatedRoute.snapshot.url[4].path);
    this.get_list_sites();
  }
  // tslint:disable-next-line:variable-name
  get_certificat(id_certificat: any) {
    this.spinner.show();
    this.certificationService.getOneCertificat(id_certificat)
      .subscribe(res => {
        // @ts-ignore
        this.single_certificats = res.data;
        this.site_id_certification = res.site_id || [];
        this.syncSelectedSites();
        if (this.single_certificats.type_validite=="2" ) {
          this.readioSelected = 2;
        }
        else {
          this.readioSelected = 1;
        }
        this.spinner.hide();
      }, (err) => {
        console.log(err);
      });
  }
  edit_certificat() {
    const body = {
      name: this.single_certificats.name,
      description: this.single_certificats.description,
      type_validite: this.readioSelected,
      date: this.single_certificats.date,
      delay: this.single_certificats.delay,
      type: this.single_certificats.type,
      id: this.single_certificats.id,
      code_article: this.single_certificats.code_article,
      code_client: this.single_certificats.code_client,
      theme: this.single_certificats.theme,
      array_site_id : [...this.hiddenSiteIds, ...this.selectedSiteIds],
    };
    this.certificationService.updateCertificats(body)
      .subscribe(res => {
        this.addingSuccess = true;
        setTimeout (() => {
          this.addingSuccess = false;
        }, 5000);
      }, (err) => {
        console.log(err);
      });
  }

  changeValidite(e) {
    this.readioSelected = e.target.value;
    this.single_certificats.type_validite=this.readioSelected;
  }
  listingSousCertificat(id: any) {
    this.certificationService.getSousCertificatbyCertificat(id)
      .subscribe(res => {
        // @ts-ignore
        this.list_sous_certificats = res.data;
      }, (err) => {
        console.log(err);
      });
  }

  add_certificat() {
    // tslint:disable-next-line:max-line-length
    if (this.certification.name === null || this.certification.description === null ) {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.checkInputs')
      });
      return false;
    }
    const body = {
      name: this.certification.name,
      description: this.certification.description,
      type_validite: this.certification.type_validite,
      date: this.certification.date,
      certificat_id: this.activatedRoute.snapshot.url[4].path,
      type: this.certification.type,
      delay: this.certification.delay
    };
   // return false;
    this.certificationService.addCertificats(body)
      .subscribe(res => {
        this.addingSuccessSous = true;
        // @ts-ignore: Unreachable code error
        this.messageText = res.message;
        this.certification.name = '';
        this.certification.description = '';
        this.certification.type_validite = '';
        this.certification.date = '';
        this.certification.type = '';
        this.listingSousCertificat(this.activatedRoute.snapshot.url[4].path);
      }, (err) => {
        console.log(err);
      });
  }

  changeValiditeSous(e) {
    this.readioSelectedSous = e.target.value;
  }

  edit_sous_certificat(id) {
    this.router.navigate(['/dashboard/administrator/sous-certifications/editer/' + id], { relativeTo: this.activatedRoute});
  }

  get_list_sites() {
    this.siteService.getSite()
      .subscribe(res => {
        const sites = res.data || [];
        this.sites = sites
          .filter(site => this.entityType !== 'EKAMPUS' || !this.isHiddenEkampusSite(site))
          .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'fr', {sensitivity: 'base'}));
        this.sitesLoaded = true;
        this.syncSelectedSites();
      }, (err) => {
        console.log(err);
      });
  }

  selectAllSites(selectAll: boolean): void {
    this.selectedSiteIds = selectAll ? this.sites.map(site => site.id) : [];
  }

  private syncSelectedSites(): void {
    if (!this.sitesLoaded || !this.site_id_certification) {
      return;
    }
    const visibleSiteIds = new Set(this.sites.map(site => String(site.id)));
    this.selectedSiteIds = this.site_id_certification.filter(siteId => visibleSiteIds.has(String(siteId)));
    // Les associations X- existantes restent inchangées lors d'une modification,
    // même si elles ne sont plus proposées dans le sélecteur E-KAMPUS.
    this.hiddenSiteIds = this.site_id_certification.filter(siteId => !visibleSiteIds.has(String(siteId)));
  }

  private isHiddenEkampusSite(site: any): boolean {
    return ((site && site.name) || '').trim().toUpperCase().startsWith('X-');
  }

}
